import { CallCenterFlow, CallHistoryRecord, IVRFlow, CallFlow } from "redux/slices/callHistory.slice";

export const getCallStatus = (record: CallHistoryRecord): string => {
  const flows = record.call_flow?.flows || [];

  // Type guards
  const isCallCenterFlow = (flow: CallFlow): flow is CallCenterFlow =>
    flow.application?.app === 'callcenter';

  const isIVRFlow = (flow: CallFlow): flow is IVRFlow =>
    flow.application?.app === 'ivr';

  // For inbound
  const callCenterFlow = [...flows].reverse().find(isCallCenterFlow);
  const ivrFlow = flows.find(isIVRFlow);

  // For outbound
  const outboundFlow = flows.find(flow => 'answered' in flow || 'hangup' in flow);

  // Primary status resolution
  if (callCenterFlow?.callcenter?.status) return callCenterFlow.callcenter.status;

  if (ivrFlow) return ivrFlow.answered ? 'answered' : 'missed';

  if (record.call_direction === 'outbound') {
    if (outboundFlow?.answered) return 'answered';
    if (record.missed_call) return 'missed';

    const hangupFlow = flows.find(flow => flow.hangup === true);
    if (hangupFlow) return 'hang up';

    return 'No answer';
  }

  const hangupFlow = flows.find(flow => flow.hangup === true);
  if (hangupFlow) return 'Hang up';

  return 'Unknown';
};
